import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Grid, Col, Row } from 'react-bootstrap'
import { Loading } from '../../../../components/shared'
import { synchronizeWithSalesforce } from '../../../actions'

const SalesforceSyncModal = (props) => {
    const {
        selectedAgency = null,
        synchronizeWithSalesforce,
        brokerages
    } = props
    const [syncInProgress, setSyncInProgress] = useState(false)
    const [disableSyncButton, setDisableSyncButton] = useState(false)

    const handleSyncWithSalesforce = event => {
        event.preventDefault()
        setSyncInProgress(true)
        setDisableSyncButton(true)
        synchronizeWithSalesforce(selectedAgency?.agencyCode)
    }

    useEffect(() => {
        if (brokerages.isSalesforceSyncBusy === false) {
            setSyncInProgress(false)
            setDisableSyncButton(false)
        }
    }, [brokerages?.isSalesforceSyncBusy])

    return (
        <div className="modal-main">
            <Grid fluid={true}>
                <Row>
                    <Col xs={12} md={12}>
                        {selectedAgency?.agencyCode ? <div className="input-label">
                            Synchronize <b>{selectedAgency.name} - {selectedAgency.agencyCode}</b> information with Salesforce.          
                        </div>
                        : <div className="input-label">
                            Synchronize Agencies with recently updated Salesforce Agency updates.          
                        </div>}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <button
                            className="btn-default btn sync-button"
                            onClick={handleSyncWithSalesforce}
                            disabled={disableSyncButton}
                        >
                            Salesforce Synchronization
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        {syncInProgress && (
                        <div>
                            <Loading width="22px" height="22px" />
                        </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        {
                        <div className="notification-text">
                            {typeof brokerages.salesforceSyncError === 'string' &&
                            brokerages.salesforceSyncError.length > 0 &&
                                <div className="error-text">
                                    {brokerages.salesforceSyncError}
                                </div>}
                        </div>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        {Array.isArray(brokerages.salesforceSuccessfulUpdates) && 
                            <div>
                                Total Agencies updated: {brokerages.salesforceSuccessfulUpdates.length}
                            </div>
                        }
                    </Col>
                </Row>
            </Grid>
        </div>
    )
}

const mapStateToProps = store => {
    return {
        brokerages: store.brokerages,
    };
};

const connectedSalesforceSyncModal = connect(mapStateToProps, { synchronizeWithSalesforce })(SalesforceSyncModal)

export { connectedSalesforceSyncModal as SalesforceSyncModal }